import {
  SpoPosterTableResponseItem,
  SpoPosterTableResponseItemSmSegmentationNeedColumnsItem,
} from '@spo/types';
import clsx from 'clsx';
import { SecondLevel } from '../SecondLevel/SecondLevel';
import './firstLevel.scss';

export const FirstLevel = ({
  content,
}: {
  content: SpoPosterTableResponseItem;
}) => {
  const technicityLevel = content.smSegmentation.technicityLevel;
  const segmentationLabel = `${technicityLevel ? `${technicityLevel} | ` : ''}${content.smSegmentation.label}`;

  const getSegColor = (techLevel: string | null) => {
    const techNumber = Number(techLevel);
    switch (techNumber) {
      case 100:
        return 'occasional';
      case 500:
        return 'regular';
      case 900:
        return 'intensive';
      default:
        return 'no-tech';
    }
  };

  const hasOneChild =
    content.smSegmentation.needColumns.length === 1 &&
    content.smSegmentation.needColumns[0].needSegmentation.smColumns.length ===
      1;

  return (
    <div
      className={clsx('first-level', { 'one-child': hasOneChild })}
      data-testid="first-level"
    >
      <div
        className={clsx('first-level-label', getSegColor(technicityLevel))}
        data-testid="first-level_label"
      >
        {segmentationLabel}
      </div>
      <div className="second-levels-container">
        {content.smSegmentation.needColumns.map(
          (
            needColumn: SpoPosterTableResponseItemSmSegmentationNeedColumnsItem,
          ) => (
            <SecondLevel
              key={needColumn.needSegmentation.id}
              content={needColumn}
            />
          ),
        )}
      </div>
    </div>
  );
};
